import { createApi } from "@reduxjs/toolkit/query/react";
import { testingUrl } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const generateLeagueAPI = createApi({
    reducerPath: "generateLeagueAPI",
    baseQuery: axiosBaseQuery({ baseUrl:testingUrl }),
    endpoints: () => ({}),
});
